"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var api_internal_contract_js_1 = require("@tableau/api-internal-contract-js");
var ServiceImplBase_1 = require("./ServiceImplBase");
var ClientInfoServiceImpl = /** @class */ (function (_super) {
    __extends(ClientInfoServiceImpl, _super);
    function ClientInfoServiceImpl() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(ClientInfoServiceImpl.prototype, "serviceName", {
        get: function () {
            return "client-info-service" /* ClientInfo */;
        },
        enumerable: true,
        configurable: true
    });
    ClientInfoServiceImpl.prototype.getClientInfoAsync = function () {
        var _a;
        var verb = api_internal_contract_js_1.VerbId.GetEmbeddingClientInfo;
        var parameters = (_a = {},
            _a[api_internal_contract_js_1.ParameterId.FunctionName] = 'getClientInfoAsync',
            _a);
        return this.execute(verb, parameters).then(function (response) {
            var clientInfo = response.result;
            return clientInfo;
        });
    };
    return ClientInfoServiceImpl;
}(ServiceImplBase_1.ServiceImplBase));
exports.ClientInfoServiceImpl = ClientInfoServiceImpl;
//# sourceMappingURL=ClientInfoServiceImpl.js.map